import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ListItem } from "../../backend/backendapi";


@Component({
    name: 'UserSelectModal'
})
export default class UserSelectModal extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    available!: ListItem[];
    @Prop({ required: true })
    selected!: ListItem | null;

    openModal(): void {
        $('#' + this.modalId).modal('show');
    }

    closeModal(): void {
        $('#' + this.modalId).modal('hide');
    }

    private close(): void {

    }

    private click(item: ListItem): void {
        this.$emit('selected', (this.selected && this.selected.id) === item.id ? null : item);
    }
}